import createVueComponent from '../createVueComponent';

const AtSign = createVueComponent('AtSignIcon', [
  ['circle', { cx: '12', cy: '12', r: '4', key: '4exip2' }],
  ['path', { d: 'M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8', key: '7n84p3' }],
]);

export default AtSign;
